import "./modules/core"
import "./bespoke/gallery"
import initImageTextListing from "./bespoke/image-text-listing"
import openNewTabLinks from "./bespoke/open-new-tab-links"

document.addEventListener("livewire:navigated", () => {
  initImageTextListing()
  openNewTabLinks()
})
